module.exports = __webpack_public_path__ + "img/Discovr-Analytics-Logo.ff2f8c69.png";